import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import VModal from 'vue-js-modal'
import FileUpload from 'v-file-upload'
import Notifications from 'vue-notification'
import VueCookies from 'vue-cookies';
import i18n from './i18n'

Vue.config.productionTip = false
Vue.use(VModal)
Vue.use(FileUpload)
Vue.use(Notifications)
Vue.use(VueCookies);

new Vue({
  router,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
